<template>
  <div>
    <div class="fileStore-title">
      <div>{{ $t("RAM.GCP.FileStore.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:filestore:update'
          ]"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:filestore:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="fileStore-top">
      <filestore-search ref="fileStoreSearchChild"></filestore-search>
    </div>
    <table-filestore></table-filestore>
  </div>
</template>

<script>
import FilestoreSearch from "../filestore/FilestoreSearch";
import TableFilestore from "../filestore/TableFilestore";

export default {
  name: "Filestore",
  components: {
    FilestoreSearch,
    TableFilestore
  },
  data() {
    return {
      modal_loading: false,
      accountNameSearchID: "",
      companyId: "",
      accountName: "",
      filestoreName: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.fileStoreSearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 404
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.companyId = this.$refs.fileStoreSearchChild.companyId;
      this.accountName = this.$refs.fileStoreSearchChild.accountName;
      this.filestoreName = this.$refs.fileStoreSearchChild.filestoreName;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportFileStore({
          companyId: this.companyId,
          accountName: this.accountName
        })
        .then(res => {
          let fileName = "Filestore.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.fileStore-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.fileStore-title > div:nth-child(1) {
  float: left;
}
.fileStore-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.fileStore-top {
  width: 100%;
  height: 53px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/filestore/Filestore.vue